import KyeAddressLabel from './label'
export default {
  name: 'KyeAddressSearchWrap',
  components: { KyeAddressLabel },
  props: {
    labelData: Object,
    validateData: {
      type: Object,
      default: () => ({})
    },
    searchProps: {
      type: Object,
      default: () => ({})
    }
  },
  render(h) {
    const { $props } = this
    const { searchProps, labelData, validateData } = $props
    const addressLabel = labelData && labelData.addressLabel
    const labelWidth = labelData && labelData.labelWidth
    const addressSearchBind = {
      props: searchProps,
      class: 'kye-address-search',
      ref: 'kyeAddressSearch',
      on: {
        blur: this.searchBlur,
        select: this.searchSelect,
        searchInput: this.searchInput,
        clear: this.searchClear,
        focus: this.searchFocus,
        mouseenter: this.searchMouseenter,
        mouseleave: this.searchMouseleave,
        change: this.searchChange
      }
    }
    const renderAddressSearch = () => {
      return <kye-address-search { ...addressSearchBind }></kye-address-search>
    }
    const renderLabel = () => {
      return <kye-address-label require={validateData.addressRequire} value={ addressLabel } labelWidth={labelWidth}></kye-address-label>
    }
    const contentAddressSearch = renderAddressSearch()
    const contentLabel = renderLabel()
    return <div class="kye-address-search-wrap">
        {contentLabel}
        {contentAddressSearch}
    </div>
  },
  methods: {
    searchBlur () {
      // change 改变的是输入框的值
      this.$emit('blur')
    },
    searchSelect (data) {
      // select 改变的是下拉选择的数据
      this.$emit('select', data)
    },
    searchInput (data) {
      this.$emit('searchInput', data)
    },
    searchClear() {
      this.$emit('clear')
    },
    searchFocus() {
      this.$emit('focus')
    },
    searchChange(val) {
      this.$emit('change', val)
    },
    searchMouseenter() {
      this.$emit('mouseenter')
    },
    searchMouseleave() {
      this.$emit('mouseleave')
    },
    // 数据验证
    validate(data, custom) {
      let validate = custom ? data.validate : data
      const errorProps = custom ? data.validateMessage : this.validateData.addressError
      return this.$refs.kyeAddressSearch.validate(validate, errorProps)
    },
    clearValidate() {
      this.$refs.kyeAddressSearch.clearValidate()
    }
  }
}






// WEBPACK FOOTER //
// ./src/public/components/kye-address/components/search-wrap.js